/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import PartnerEmailPreferencesList from 'bundles/account-settings/components/sections/email-preferences/PartnerEmailPreferencesList';
import type { PartnerEmailPreference, UpdateStatus } from 'bundles/account-settings/types/EmailPreferences';

import _t from 'i18n!nls/account-settings';

type Props = {
  disabled: boolean;
  partnerPreferences: PartnerEmailPreference[];
  updateStatus: UpdateStatus;
};

const styles = {
  title: css`
    margin-block-end: var(--cds-spacing-100);
  `,
  supportText: css`
    margin-block-end: var(--cds-spacing-200);
  `,
  captionText: css`
    margin-block-start: var(--cds-spacing-400);
  `,
};

const PartnerEmailPreferences = ({ disabled, partnerPreferences, updateStatus }: Props) => (
  <div>
    <Typography2 component="h2" variant="subtitleMedium" css={styles.title}>
      {_t('Partner communications')}
    </Typography2>
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.supportText}>
      {_t(
        'Receive general information about online and on-campus courses and programs, special events, and publications from the Coursera partners whose courses you are taking.'
      )}
    </Typography2>
    <PartnerEmailPreferencesList
      disabled={disabled}
      partnerPreferences={partnerPreferences}
      updateStatus={updateStatus}
    />
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.captionText}>
      {_t(
        `If you decide not to receive general information from a Coursera partner whose course you have taken,
          Coursera will inform the institution of your decision.  Should you continue to receive emails from the
          institution, please contact it directly to remove yourself
          (e.g., by unsubscribing from the institution's email lists).`
      )}
    </Typography2>
  </div>
);

export default PartnerEmailPreferences;
